var React = require("react");

var _ = require("underscore");

var T = React.PropTypes;

var Dispatcher = require("../Dispatcher");

var moment = require("moment");

var ALikeStore = require("../store/ALikeStore");

var QuoteStatus = require("../conf/quote-status");

var OrderStatus = require("../conf/order-status");

var {ActionConstants, EventConstants} = require("../Constants");

var {object2class} = require("../util/clazz");

var {format} = require("../util/price");

var Countdown = require("../cutil/Countdown");

var pollQuoteService = require("../detail/pollQuoteService");

var versionIdsCollection = [];

/**
 * 计价列表倒计时
 */
var QuoteCountdown = ({quote,onInvalid})=>
    <span className="cell-count-down">
            <i className="icon-product-timer"></i>
            <Countdown left={ALikeStore.get_recordInvalidSeconds(quote.inquiryKey)}
                         onInvalid={ onInvalid } data={quote}/>内有效
    </span>



var hasCountdown = (quote)=>{

    var version = ALikeStore.get_recordDefaultVersion(quote.inquiryKey, true);

    if ( version.valid && !quote.isExpired ) {
        return true
    }else{
        return false
    }

}


var _getRecordStatus = (quote)=> {
    var getVersion = ()=> ALikeStore.get_recordCurrentVersion(quote.inquiryKey, true);

    var orderStatus  = quote.orderStatus;

    var dateList = quote.priceCalenderDataList;

    var isDateNear = quote.isDateNear && quote.inquiryType==1;
    //状态分解, 报价前,报价中,下单及下单之后,后期需要处理,目前状态为后端对应的map,前端显示需要做条件合并/多条件,出render需要的状态
    var recordStatus = [
        {
            text: '已付定金',
            condition: ()=> orderStatus === OrderStatus.partPayed.code
        },
        {
            text: '已付全款',
            condition: () => orderStatus === OrderStatus.fullPayed.code

        },
        {
            text: '退款成功',
            condition: ()=> false
        },
        {
            text: '计算中',
            condition: ()=> dateList.every(item=> item.status === QuoteStatus.Calculating.code )
        },
        {
            text : '欢迎询价',
            condition : function () {

                var version = getVersion();

                if( quote.isExpired ){
                    return false
                }

                if( !version.valid || isDateNear ){
                    return true
                }

                if( version.status === QuoteStatus.Normal.code || version.status === QuoteStatus.Mistake.code ){
                    return false
                }else{
                    return true
                }


            }
        },
        {
            text: '价格已过期',
            condition: () => quote.isExpired
        }
    ].filter(item=> item.condition());

    return recordStatus
}

/**
 * 显示当前报价记录状态
 */
var QuotePriceStatus = ({quote})=> {
    var getVersion = ()=> ALikeStore.get_recordCurrentVersion(quote.inquiryKey, true);
    var recordStatus =  _getRecordStatus(quote);

    return  recordStatus[0]
                ? <em>{ recordStatus[0].text} </em>
                : <em> {"￥" + format(getVersion().perPrice) + " 元/人" }</em>
};

var QuoteCompareBtn = ({quote})=> {

    var recordStatus = _getRecordStatus(quote);
    return recordStatus[0]
            ? <noscript/>
            : <button className="compare-btn js-compare-btn">+对比</button>
}

var QuoteRecordList = React.createClass({

    propTypes: {
        collapsed: T.bool,
        switched: T.bool
    },

    componentWillMount(){

        ALikeStore.on(EventConstants.AJAX_RETRIEVE_RECORD_LIST_COMPLETE, this.on_retrieveRecordListComplete);

    },
    componentWillUnmount(){
        ALikeStore.off(EventConstants.AJAX_RETRIEVE_RECORD_LIST_COMPLETE, this.on_retrieveRecordListComplete);
    },

    on_quoteInvalid(info){
        Dispatcher.dispatch({
            type: ActionConstants.ALERT_QUOTE_BECOME_INVALID,
            data: info
        });
    },
    /**
     * 询价列表返回
     */
    on_retrieveRecordListComplete(){
        this.sendNotify();
    },
     /**
     * 询价列表click事件
     * @param quote
     */
    handle_selectQuote(quote,e){

        // 去掉选中的 quote 上 new 图标
        pollQuoteService.cancelNewQuote(quote.inquiryKey);

        Dispatcher.dispatch({type:ActionConstants.LOADING_LAYER_SHOW});
        Dispatcher.dispatch({type: ActionConstants.SWITCH_QUOTE_RECORD, data: quote});

    },

    /**
     * 发送通知
     * 每条询价返回都会发送一条通知
     */
    sendNotify(){

        // var  isExpired
        var newVersions = pollQuoteService.getNewVersions();
        var updateVersions = newVersions;

        if( versionIdsCollection.length !== 0 ){
            updateVersions = _.difference( newVersions, versionIdsCollection );
        }

        if( updateVersions.length ){

            Dispatcher.dispatch({type: ActionConstants.ADD_NOTIFY, message:`您有 ${ updateVersions.length } 条价格更新`});

        }

        versionIdsCollection = versionIdsCollection.concat(updateVersions);
    },

    render() {
        var self = this;

        if (this.props.collapsed) {
            return null;
        }

        var quoteRecordList = ALikeStore.get_quoteRecordList();
        var inquiryKey = ALikeStore.get_currentRecord();

        if (!this.props.switched) {
            inquiryKey = null;
        }

        var newQuotes = pollQuoteService.getNewQuotes();

        quoteRecordList = quoteRecordList.map((item)=>{

            if( _.contains(newQuotes, item.inquiryKey) ){

                item.isNew = true;
            }else{
                item.isNew = false;
            }

            return item

        });
        return (


            <div className="quote-result-list">

                {quoteRecordList.length > 0 ? (
                    <div className="title-tools">
                        <div className="title">实时价格</div>
                            {quoteRecordList.length>5 ? (
                                <div className="add-all">
                                    <a href={`/u${trip.uid}/route/`}><span className="items"><i className="icon-indicator-all"></i>全部</span></a>
                                </div>
                            ) : null }
                    </div>

                ) : null}

                {_.map(quoteRecordList, function (quote) {

                    var selected = inquiryKey === quote.inquiryKey;
                    var qrItemClazz = object2class({
                        'qr-item': true,
                        selected: selected
                    });
                    var orderStatus  = quote.orderStatus;
                    var version = ALikeStore.get_recordDefaultVersion(quote.inquiryKey, true);

                    return (
                        <a href="#summary" className={qrItemClazz} key={quote.inquiryKey}
                           onClick={(e)=>self.handle_selectQuote(quote,e)}
                           data-startdate={quote.startDate}>
                            <div className="inner">
                                {
                                    quote.isNew ? <i className="icon-product-new"></i> : null
                                }
                                <div className="result">
                                    {
                                        hasCountdown(quote)
                                            ? <QuoteCountdown quote={ quote } onInvalid={self.on_quoteInvalid}/>
                                            : null
                                    }

                                </div>
                                <div><span
                                    className="depart-date">{moment(quote.startDate).format("MMMDo")}</span>&nbsp;<span
                                    className="depart-city">{quote.startCityName}</span>出发
                                </div>
                                <div>
                                    <QuotePriceStatus quote={ quote }/>
                                </div>
                                <QuoteCompareBtn quote={ quote } />
                            </div>
                        </a>
                    );
                })}
            </div>
        );
    }
});

module.exports = QuoteRecordList;




/** WEBPACK FOOTER **
 ** ./script/detail/QuoteRecordList.jsx
 **/